let h2 = document.querySelectorAll('.heading_color__custom');
let ob_arr = [];
let color = ['#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51']
let heading = Array.from(h2);
let ar_length = heading.length;
heading.forEach((headin, index)=>{
    let obj = {
        name: headin.innerText,
        mixing : function (){
            heading[index].innerHTML = '';
            let newStr = this.name.split('');
            for(i=0;i<newStr.length;i++){
            heading[index].innerHTML += `<span style="color: ${color[i]}">${newStr[i]}</span>`;
            }
        }
    }

    ob_arr.push(obj);
})

for(elem in heading){
    ob_arr[elem].mixing();
}























// let h = document.querySelector('.heading_color__custom');
// let str = h.innerText;
// let color = ['#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51','#cc2527','#ff9a37','#e480d4','#468fec','#2dc27a','#bf7a51'];
// let stringS = str.split('');
// h.innerHTML = "";
// stringS.forEach((col, index)=>{
//     h.innerHTML += `<span style="color: ${color[index]};">${col}</span>`;
// })